import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import ScrollToTopButton from '@/components/feature/ScrollToTopButton';
import HeroSection from '@/pages/home/components/HeroSection';
import HotRanking from '@/pages/home/components/HotRanking';
import LatestGrid from '@/pages/home/components/LatestGrid';
import FaqSection from '@/pages/home/components/FaqSection';
import BrandStrip from '@/pages/home/components/BrandStrip';
import { useSeo } from '@/hooks/useSeo';
import { faqs } from '@/mocks/faqs';
import { siteInfo } from '@/mocks/site';

export default function Home() {
  useSeo({
    title: '瓜田快报｜私拍吃瓜名场面·抓拍·高光瞬间盘点',
    description:
      '瓜田快报专注私拍吃瓜名场面与抓拍盘点,把神操作、尴尬瞬间、高光瞬间集中整理,最新热门优先展示,点标题即可快速定位关键画面。',
    keywords: '私拍吃瓜,私拍吃瓜名场面,私拍吃瓜抓拍,私拍吃瓜神操作,私拍吃瓜尴尬瞬间,私拍吃瓜高光瞬间',
    path: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.domain,
        description: siteInfo.description,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteInfo.domain}/moments?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: siteInfo.name,
        url: siteInfo.domain,
        email: siteInfo.email,
        description: siteInfo.description,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <HotRanking />
        <LatestGrid />
        <FaqSection />
        <BrandStrip />
      </main>
      <SiteFooter />
      <ScrollToTopButton />
    </div>
  );
}